import Immutable from 'immutable';
import React from 'react';

import Validation, { Form } from 'modules/react-validation';

import Button from 'sharedreact/components/Button';
import List from 'sharedreact/components/List';
import ModalBackground from 'sharedreact/components/ModalBackground';
import ParameterComponent from 'sharedreact/components/ParameterComponent';
import ParameterSet from 'sharedreact/components/ParameterSet';
import Row from 'sharedreact/components/Row';
import SlideOut from 'sharedreact/components/SlideOut';
import TextInfoField from 'sharedreact/components/TextInfoField';
import User from 'sharedreact/data/User';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  activeUser: User,
  locations: Immutable.List<string>,
  language: string,
  show: boolean,
  
  onChangePassword: () => void,
  onClose: () => void
};

class AccountSlideOut extends React.Component<Props> {
  private form: Form | null;

  constructor (props: Props) {
    super(props);

    this.form = null;

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose (): void {
    this.form!.validateAll();

    if (Object.keys(this.form!.getErrors()).length === 0) {
      this.props.onClose();
    }
  }

  override render (): React.ReactNode {
    const { activeUser, locations, language, show, onChangePassword } = this.props;

    if (!activeUser) {
      return null;
    }

    return (
      <ModalBackground
        visible={show}
        className='esko_accountslideoutbackground'
        onClick={this.handleClose}>
        <SlideOut id='ae_slideout_account'
          language={language}
          visible={show}
          className='esko_accountslideout'
          onClose={this.handleClose}
          canClose
          alignRight>
          <Validation.components.Form
            ref={c => { this.form = c; }}
            className='esko_container'>
            <Row>
              <ParameterSet title={translate('shared.account.title')}>
                <TextInfoField id='ae_field_account_user_name'
                  label={translate('shared.account.username')}
                  value={activeUser.name} />
                <TextInfoField id='ae_field_account_full_name'
                  label={translate('shared.account.fullname')}
                  value={activeUser.fullName} />
                <TextInfoField id='ae_field_account_email'
                  label={translate('shared.account.email')}
                  value={activeUser.email} />
                {locations.size !== 0
                ? <ParameterComponent
                  className='esko_account_locations'
                  inputId='ae_field_account_locations'
                  label={translate('shared.account.locations')}>
                  <List id='ae_field_account_locations'
                    selected={-1}
                    onChangeSelection={() => {}}>
                    {locations.map((location) => <span key={location}>{location}</span>)}
                  </List>
                </ParameterComponent>
                : null}
                { activeUser.userType === 'internal' && // At this moment we only support changing password for internal users
                  <ParameterComponent
                    inputId='ae_button_account_change_password'
                    label=''
                    inputContainer={false}>
                    <div className='esko_forminput'>
                      <Button
                        id='ae_button_account_change_password'
                        onClick={onChangePassword}>
                        {translate('shared.account.changepassword')}
                      </Button>
                    </div>
                  </ParameterComponent>
                }
              </ParameterSet>
            </Row>
          </Validation.components.Form>
        </SlideOut>
      </ModalBackground>
    );
  }
}

export default AccountSlideOut;
